module.exports = __webpack_public_path__ + "img/28_57.7b4cd48c.png";